module.exports = __webpack_public_path__ + "static/img/order.1b05667.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/order/order.jpg
// module id = BAJm
// module chunks = 3